import { AnyAction } from 'redux';
import { ResultsAction } from '../actions/results';

interface initState {
  pkStatus: number,
  pkSessionId: number | string,
  navKey: number,
  resultsList: any[],
}

export default function Login(state: initState  = {
  pkStatus: -1, 
  pkSessionId: 0,
  navKey: 0,
  resultsList: []
}, action: AnyAction) {
  switch (action.type) {
    case ResultsAction.SET_PROPERTY:
      return { ...state, ...action.payload }
    case ResultsAction.SET_RESULTS_LIST:
      return { ...state, ...action.payload }
    default:
      return { ...state }
  }
}